<template>
  <div class="flex items-start justify-start text-[15.33px] font-medium w-full">
    <span class="min-w-[172px] text-[#626262] shrink-0">{{ label }}</span>
    <span
      class="text-[#000000] min-w-0"
      style="overflow-wrap: anywhere;"
    ><slot /></span>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
  },
}
</script>
